// import RulePack from './RulePack';

export default {
  priority: 0,
  path: "ApiSettings",
  permissions: ["RequestsMenu/RequestPattern/PatternDefinitionMenu"],
  // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./Log")
  ),
  name: app.translate("تاریخچه"),
  icon: "content-paste",
  drawer: true,
};
